import { createFileRoute } from "@tanstack/react-router";
import { requireSignedIn } from "../auth/requireSignedIn";
import { AppInvite } from "../features/appInvite/AppInvite";
import { SectionScreen } from "../shell/SectionScreen";
export const Route = createFileRoute("/refer")({
  beforeLoad: requireSignedIn,
  component: () => (
    <SectionScreen heading="Refer a friend">
      <AppInvite />
    </SectionScreen>
  ),
});
